<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {};
</script>

<style lang="less">
/deep/ .el-table .el-table__cell {
  padding: 5px 0;
}
</style>
